// extracted by mini-css-extract-plugin
module.exports = {"Rubricator":"spUUy","Rubricator__BackIcon":"EzaMm","Rubricator__BackButton":"JxxuE"};